import React, { useState, useCallback, useEffect } from "react";
import PageContainer from "../../components/PageContainer";
import Container from "../../components/Container";
import MainCard from "../../components/MainCard";
import AccordionItem from "../../components/AccordionItem";
import { getAboutITA } from "../../api/about";
import ImageWithTooltip from "../../components/ImageWithTooltip";
import { Link } from "react-router-dom";

const ItaPage = () => {
  const [rows, setRows] = useState([]);
  const [pageData, setPageData] = useState("");

  const getData = useCallback(
    () =>
      getAboutITA()
        .then((res) => {
          const mapData = res.docsyear.map((item) => {
            return {
              title: item.yeartitle,
              image: item?.yearsbanner?.path,
              children: item.docsgroup.map((doc) => {
                return {
                  title: doc.grouptitle,
                  children: doc.items.map((subDoc) => {
                    return {
                      title: subDoc.docstitle,
                      link: subDoc.docslink,
                    };
                  }),
                };
              }),
            };
          });
          setRows(mapData);

          setPageData(res);
        })
        .catch((err) => console.log(err)),
    [setRows]
  );

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <PageContainer bgImg="/images/hero-image.jpeg" title={pageData?.title}>
      <Container isAlignTop>
        <MainCard className="min-h-[1200px]">
          {rows.map((item, index) => (
            <AccordionItem
              key={index}
              title={item.title}
              className=""
              contentClassName="bg-[#fff]"
            >
              {item.image && (
                <ImageWithTooltip
                  src={item.image}
                  alt={item.title}
                  className="w-full"
                />
              )}
              {item.children.map((child, index) => (
                <AccordionItem
                  key={index}
                  title={child.title}
                  className=" bg-[#272974]"
                  headerClassName="text-white"
                  contentClassName="bg-[#fff] flex flex-col gap-1"
                >
                  {child.children.map((subChild, index) => (
                    <div key={index} className="p-5 rounded-lg bg-[#E9EAF8]">
                      <Link
                        target="_blank"
                        to={subChild.link}
                        className="text-[#272974]"
                      >
                        {subChild.title}
                      </Link>
                    </div>
                  ))}
                </AccordionItem>
              ))}
            </AccordionItem>
          ))}

          <hr className="my-4" />

          <div dangerouslySetInnerHTML={{ __html: pageData?.memo }} />
        </MainCard>
      </Container>
    </PageContainer>
  );
};

export default ItaPage;
